import axios from 'axios';

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 可以在这里添加 token 等认证信息
    // const token = localStorage.getItem('token');
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`;
    // }
    return config;
  },
  (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;

    // 根据业务需求判断响应状态（支持 code 为 0 或 200）
    if (res.code !== 0 && res.code !== 200) {
      console.error('接口错误:', res.msg || '请求失败');
      return Promise.reject(new Error(res.msg || '请求失败'));
    }

    return res;
  },
  (error) => {
    console.error('响应错误:', error.message);
    return Promise.reject(error);
  },
);

// 通用请求方法
export const request = {
  get(url: string, params?: any, config?: any) {
    return service.get(url, { params, ...config });
  },

  post(url: string, data?: any, config?: any) {
    return service.post(url, data, config);
  },

  put(url: string, data?: any, config?: any) {
    return service.put(url, data, config);
  },

  delete(url: string, params?: any, config?: any) {
    return service.delete(url, { params, ...config });
  },
};

export default service;
